import _slicedToArray from '../node_modules/@babel/runtime/helpers/esm/slicedToArray.js';
import { curry, compose, head, union, props, flatten, map, isEmpty } from 'ramda';
import computePossibleMT from './computePossibleMT.js';
import getAttackerRoutes from './getAttackerRoutes.js';
import getAttackers from './getAttackers.js';
import getDefenders from './getDefenders.js';
import '../utils/createTimeline.js';
import '../utils/convertAxisListToTiles.js';
import '../utils/convertAxisToTile.js';
import '../utils/parseCode.js';
import '../utils/detectDarkTile.js';
import _detectPiece from '../utils/detectPiece.js';
import '../utils/detectOpponent.js';
import '../utils/detectMoved.js';
import '../utils/detectEnemyOnTiles.js';
import '../utils/detectTurn.js';
import '../utils/detectContacted.js';
import '../utils/findCode.js';
import '../utils/findCodeByTile.js';
import findOpponentKing from '../utils/findOpponentKing.js';
import '../utils/getNextFileByIndex.js';
import '../utils/getNextRankByIndex.js';
import '../utils/getPKeyByTile.js';
import '../utils/getEqualPieces.js';
import '../utils/getSymmetryTile.js';
import '../utils/getAnimationAxis.js';
import '../utils/getDirection.js';
import '../utils/getTilesDifference.js';
import _removeDirection from '../utils/removeDirection.js';
import '../utils/removeCodeByTile.js';
import '../utils/replaceCode.js';
import '../presets/rules.js';
import '../utils/validateTile.js';
import filterOpponent from '../utils/filterOpponent.js';
import '../utils/computeDistance.js';
import pretendTo from '../utils/pretendTo.js';
import '../utils/transformInto.js';
import '../utils/diffSnapshot.js';
import '../utils/subInBetweenIndexes.js';

function computeCheckState(e,t){var r=compose(findOpponentKing(e),head)(t),o=getAttackers(r,t),i=head(o)||"",n=1===o.length,c=[],p=[],s=[],a=[];if(i&&(c=o.reduce((function(e,o){return compose(union(e),getAttackerRoutes(t,o),pretendTo(r))(o)}),[]),n)){var m=compose(props(["of","tiles"]),getDefenders(i,t))(c),d=_slicedToArray(m,2);p=d[0],s=d[1];}var f=compose(flatten,map((function(e){var r=computePossibleMT(i,c,e,t);return _detectPiece.Pawn(e)&&(r=_removeDirection.Vertical(r,e)),_detectPiece.King(e)&&(a=r),r})),filterOpponent(e),head)(t),u=isEmpty(p)&&isEmpty(s),l=!!i;return {isCheck:l,isStalemate:!l&&isEmpty(f),isCheckmate:l&&u&&isEmpty(a),data:{kingCode:r,defenders:p,defendTiles:s,attackerCode:i,attackerRoutes:c,dodgeableTiles:f}}}var computeCheckState$1 = curry(computeCheckState);

export { computeCheckState$1 as default };
//# sourceMappingURL=computeCheckState.js.map
